import React, { useEffect, useState, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Calendars } from "../../../components/Calendar/Calendar";
import { useHistory } from "react-router-dom";
import { DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateAPI } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";

// PAGE
import P233List_2 from "./P233List_2";

// SERVICE
import { pP2Info, pP2Update } from "../../../service/200/P233Service";
import { pdfRPT234 } from "../../../Report/234/RPT234PDF";
import { RPT234Word } from "../../../Report/234/RPT234Word";

import { pP2Print } from "../../../service/200/P234Service";

export default function P233Edit_2() {
    const history = useHistory();

    const toast = useRef(null);
    const [loading, setLoading] = useState(false);

    //Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // DIALOG PDF
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });
    const [dataRPT, setDataRPT] = useState([]);

    // SEARCH
    const [searchData, setSearchData] = useState({ contractNo: "", userId: dataUserSession() ? dataUserSession().userId : "" });

    // DATA
    const [dataTable, setDataTable] = useState([]);
    const [formData, setFormData] = useState({ p2LetterDate: new Date(), invoiceDate: new Date(), p2LetterTo: "", p2LetterNo: "" });
    const [errData, setErrData] = useState(null);
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                });
            } else {
                history.push("/233Edit_1");
                // setSearchData({
                //     withdrawSeq: 3,
                //     contractNo: "ป.16-1/64",
                //     userId: "s16",
                // });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.withdrawSeq !== undefined) onGetpP2Info();
    }, [searchData]);

    const onGetpP2Info = () => {
        setLoading(true);
        pP2Info(searchData).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                            invoiceDate: element.invoiceDate === null ? new Date() : element.invoiceDate,
                            p2LetterDate: element.p2LetterDate === null ? new Date() : element.p2LetterDate,
                        });
                        index++;
                    });
                    setFormData(temp[0]);
                    setDataTable(convertForDataTable(temp[0]));
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const convertForDataTable = (data) => {
        let temp = [
            { index: 0, itemValue: data.item1Value, itemDesc: data.item1Desc },
            { index: 1, itemValue: data.item2Value, itemDesc: data.item2Desc },
            { index: 2, itemValue: data.item3Value, itemDesc: data.item3Desc },
            { index: 3, itemValue: data.item4Value, itemDesc: data.item4Desc },
            { index: 4, itemValue: data.item5Value, itemDesc: data.item5Desc },
            { index: 5, itemValue: data.item6Value, itemDesc: data.item6Desc },
            { index: 6, itemValue: data.item7Value, itemDesc: data.item7Desc },
            { index: 7, itemValue: data.item8Value, itemDesc: data.item8Desc },
            { index: 8, itemValue: data.item9Value, itemDesc: data.item9Desc, itemDetail: data.item9Detail, total: data.itemTotalValue },
        ];
        return temp;
    };

    const submitForm = (act) => {
        setLoading(true);

        const checkItemValue = (value) => {
            return value === null ? 0 : value;
        };

        const req = {
            contractNo: searchData.contractNo,
            invoiceDate: formData.invoiceDate === "" ? "" : formatDateAPI(formData.invoiceDate),
            invoiceNo: formData.invoiceNo === null ? "" : formData.invoiceNo,
            item1Value: checkItemValue(dataTable[0].itemValue),
            item2Value: checkItemValue(dataTable[1].itemValue),
            item3Value: checkItemValue(dataTable[2].itemValue),
            item4Value: checkItemValue(dataTable[3].itemValue),
            item5Value: checkItemValue(dataTable[4].itemValue),
            item6Value: checkItemValue(dataTable[5].itemValue),
            item7Value: checkItemValue(dataTable[6].itemValue),
            item8Value: checkItemValue(dataTable[7].itemValue),
            item9Detail: dataTable[8].itemDetail === null ? "" : dataTable[8].itemDetail,
            item9Value: checkItemValue(dataTable[8].itemValue),
            lastWithdrawFlag: formData.lastWithdrawFlag === null ? "N" : formData.lastWithdrawFlag,
            p2LetterDate: formData.p2LetterDate === "" ? "" : formatDateAPI(formData.p2LetterDate),
            p2LetterNo: formData.p2LetterNo === null ? "" : formData.p2LetterNo,
            p2LetterTo: formData.p2LetterTo === null ? "" : formData.p2LetterTo,
            remark: formData.remark === null ? "" : formData.remark,
            userId: searchData.userId,
            withdrawSeq: searchData.withdrawSeq,
        };

        pP2Update(req).then(
            (res) => {
                setLoading(false);
                const _r = res[0];
                if (_r.statusCode === "C") {
                    // showMessages("success", "", "บันทึกสมบูรณ์");
                    setdialogOption({
                        ...dialogOption,
                        // header: alert.statusCode == "C" ? "สำเร็จ" : "ผิดพลาด",
                        header: "",
                        content: res[0].statusText,
                        footerBtn: () => footerButtonSingle(),
                    });
                    setConfirmDialog({ open: true });
                    onGetpP2Info();
                } else {
                    showMessages("error", "", "มีข้อผิดพลาด");
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValViewForm = (_key) => {
        if (formData != undefined) return formData[_key];
    };

    const setvalForm = (key, val) => {
        setFormData({ ...formData, [key]: val });
    };

    const onExport = (act) => {
        switch (act) {
            case "PDF":
                pdfRPT234(dataRPT, setLoading, setDialogPDF);
                break;

            case "WORD":
                RPT234Word(dataRPT, setLoading);
                break;
            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const handlerLoadDataReport = (req) => {
        setLoading(true);
        pP2Print(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    if (temp.length > 0) {
                        setDataRPT(temp[0]);
                        setDialogReport({ dialog: true, show: false });
                    }
                } else {
                    showMessages(toast, "error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const headlerInpusText = useCallback(
        (e, rowData, inputname) => {
            const objIndex = dataTable.findIndex((obj) => obj.index == rowData.index);
            dataTable[objIndex][inputname] = e;
            setCount(count + 1);
            setDataTable(dataTable);
        },
        [dataTable, count]
    );

    const handlerGoPage = (obj) => {
        switch (obj.page) {
            case "233":
                history.push({ pathname: `/${obj.page}`, state: { contractNo: obj.contractNo } });
                break;

            case "PRINT":
                handlerLoadDataReport({ contractNo: searchData.contractNo, withdrawSeq: searchData.withdrawSeq, userId: searchData.userId });
                break;

            default:
                break;
        }
    };

    const footerButtonSingle = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    handlerGoPage({
                        page: "233",
                        contractNo: searchData.contractNo,
                    });
                }}
            />
        );
    };

    return (
        <>
            <Loading loading={loading} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <ValidateService err={errData} setErr={setErrData} />
                <div className="p-col-12">
                    <div className="card">
                        <h3>บันทึกเพิ่มแก้ไข สรุปขอเบิกจ่ายเงิน P2</h3>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={searchData.contractNo} maxLength={20} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">P2 งวดที่</label>
                                <InputText id="contractNo" type="text" value={searchData.withdrawSeq} maxLength={5} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-2"></div>
                        </div>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="p2LetterNo">เลขที่</label>
                                <InputText id="p2LetterNo" type="text" placeholder="ระบุ เลขที่" value={setValViewForm("p2LetterNo")} maxLength={50} onChange={(e) => setvalForm("p2LetterNo", e.target.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="p2LetterDate">วันที่</label>
                                <Calendars key="p2LetterDate" id="fixExpireDate" value={new Date(setValViewForm("p2LetterDate"))} onChange={(e) => setvalForm("p2LetterDate", e.target.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="p2LetterTo">เรียน</label>
                                <InputText id="p2LetterTo" type="text" value={setValViewForm("p2LetterTo")} placeholder="ระบุ เรียน" onChange={(e) => setvalForm("p2LetterTo", e.target.value)} maxLength={500} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="p2Reference">สร้างตามแบบฟอร์ม P-1</label>
                                <InputText id="p2Reference" type="text" value={setValViewForm("p2Reference")} maxLength={50} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="totalRoute">จำนวน/เส้นทาง</label>
                                <InputText id="totalRoute" type="text" value={setValViewForm("totalRoute")} maxLength={10} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="invoiceNo">ใบแจ้งหนี้ผู้รับจ้างเลขที่</label>
                                <InputText id="invoiceNo" type="text" placeholder="ระบุ ใบแจ้งหนี้ผู้รับจ้างเลขที่" value={setValViewForm("invoiceNo")} onChange={(e) => setvalForm("invoiceNo", e.target.value)} maxLength={50} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-col-12 p-md-5">
                                <div className="p-field-checkbox">
                                    <Checkbox
                                        id="lastWithdrawFlag"
                                        type="text"
                                        checked={setValViewForm("lastWithdrawFlag") === "Y" ? true : false}
                                        onChange={(e) => {
                                            setvalForm("lastWithdrawFlag", e.checked === true ? "Y" : "N");
                                        }}
                                    />
                                    <label htmlFor="lastWithdrawFlag">เบิกจ่ายเงินงวดสุดท้าย</label>
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="invoiceDate">ลงวันที่</label>
                                <Calendars key="invoiceDate" id="invoiceDate" value={new Date(setValViewForm("invoiceDate"))} onChange={(e) => setvalForm("invoiceDate", e.target.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="remark">หมายเหตุ</label>
                                <InputText id="remark" type="text" value={setValViewForm("remark")} placeholder="ระบุ หมายเหตุ" onChange={(e) => setvalForm("remark", e.target.value)} maxLength={500} />
                            </div>
                        </div>

                        <P233List_2 dataTable={dataTable} setheadlerInpusText={headlerInpusText} />

                        <br />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button btn-hidden-responsive" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm("U")} />
                                <Button className="p-button-secondary p-button btn-hidden-responsive" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerGoPage({ page: "233", contractNo: searchData.contractNo })} />
                                {/* <Button className="p-button-warning p-button p-mr-2 p-mb-2" icon="pi pi-trash" label="ลบรายการ" style={{ width: 170, marginLeft: "5px" }} onClick={() => submitForm("D")} /> */}
                                <Button className="p-button-indo p-button btn-hidden-responsive" icon="pi pi-print" label="พิมพ์" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerGoPage({ page: "PRINT" })} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} />
            <DialogOpenReport header="พิมพ์รายงานการประเมิน" dialog={dialogPDF} setDialog={setDialogPDF} />
        </>
    );
}
